export default __webpack_public_path__ + "static/media/mix2.b438e9c6.jpg";